import { Controller } from "@hotwired/stimulus"

// Handles event form interactions including datetime auto-fill, date validation, and loading states
export default class extends Controller {
  static targets = ["startsAt", "endsAt", "occursOn", "endsOnDate", "dateError"]

  // Validate that end date is not before start date
  validateDates() {
    if (!this.hasOccursOnTarget || !this.hasEndsOnDateTarget) return

    const occursOn = this.occursOnTarget.value
    const endsOn = this.endsOnDateTarget.value

    // Clear any previous error
    if (this.hasDateErrorTarget) {
      this.dateErrorTarget.textContent = ""
      this.dateErrorTarget.classList.add("hidden")
    }

    // If end date is empty, no validation needed
    if (!endsOn) return

    // If start date is empty, can't validate yet
    if (!occursOn) return

    // Compare YYYY-MM-DD strings directly (lexicographically sortable)
    if (endsOn < occursOn) {
      if (this.hasDateErrorTarget) {
        this.dateErrorTarget.textContent = "End date must be on or after start date"
        this.dateErrorTarget.classList.remove("hidden")
      }
      this.endsOnDateTarget.setCustomValidity("End date must be on or after start date")
    } else {
      this.endsOnDateTarget.setCustomValidity("")
    }
  }

  // When starts_at changes, suggest end time (1 hour later) if not set
  updateEndTime() {
    if (!this.hasStartsAtTarget || !this.hasEndsAtTarget) return

    const startsAtValue = this.startsAtTarget.value
    if (!startsAtValue) return

    // Only auto-fill if ends_at is empty
    if (this.endsAtTarget.value) return

    const startsAt = new Date(startsAtValue)
    if (isNaN(startsAt.getTime())) return

    // Add 1 hour
    const endsAt = new Date(startsAt.getTime() + 60 * 60 * 1000)
    this.endsAtTarget.value = this.formatDatetimeLocal(endsAt)
  }

  // Format a Date object for datetime-local input
  formatDatetimeLocal(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    const hours = String(date.getHours()).padStart(2, "0")
    const minutes = String(date.getMinutes()).padStart(2, "0")

    return `${year}-${month}-${day}T${hours}:${minutes}`
  }

  /**
   * Handle form submission start - show loading state
   */
  formLoading() {
    this.element.dataset.loading = "true"
  }

  /**
   * Handle form submission end - hide loading state
   */
  formLoaded() {
    this.element.dataset.loading = "false"
  }
}
